import { Component } from "react";
import PropTypes from "prop-types";
import styles from "./speech-bubble-general.module.less";
import { extract, EventAggregator } from "@parksandresorts/core";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";

export default class SpeechBubbleGeneral extends Component {
  static propTypes = {
    poisitionOver: PropTypes.bool,
    belongsTo: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.imageInBubble = extract(props, "imageInBubble.file.url");
    this.title = extract(props, "title");
    this.componentTheme = extract(props, "componentTheme");
    this.speechBubbleInverseColors = extract(props, "speechBubbleInverseColors");
    this.speechBubbleLink = extract(props, "speechBubbleLink.internalLink.slug");
    this.poisitionOver = extract(props, "poisitionOver");
    this.link = this.speechBubbleLink ? this.speechBubbleLink : this.props.externalUrl;
    this.bubbleBelongsTo = extract(props, "bubbleBelongsTo");
  }

  render() {
    return (
      <div
        className={[
          styles.speechBubbleContainer,
          this.componentTheme ? `component-theme-${this.componentTheme}` : "",
        ].join(" ")}
      >
        <LinkWrapper
          url={this.link}
          onPreNavigate={() =>
            EventAggregator.publish("trackEvent", {
              category: "Speech Bubble",
              action: "Clicked link",
              label: this.title && this.title,
            })
          }
        >
          <div
            className={[
              styles.containerLink,
              styles["position" + this.bubbleBelongsTo],
              this.poisitionOver ? styles.over : "",
            ].join(" ")}
          >
            <div
              className={[
                this.speechBubbleInverseColors ? styles.inverseColors : "",
                styles.wrapper,
                this.poisitionOver ? styles.over : "",
                styles["position" + this.bubbleBelongsTo],
              ].join(" ")}
            >
              {this.imageInBubble && (
                <div className={styles.imageWrapper}>
                  <img className={styles.image} src={this.imageInBubble} alt="img" />
                </div>
              )}
              {this.title && (
                <div className={styles.headlineWrapper}>
                  <h6 className={styles.headline}>{this.title}</h6>
                </div>
              )}
              {this.link && <span className={["icon-chevron_right", styles.icon].join(" ")} />}
            </div>
          </div>
        </LinkWrapper>
      </div>
    );
  }
}
